import WarningText from './WarningText'

export default WarningText
